import { render, staticRenderFns } from "./SubheadingInput.vue?vue&type=template&id=4500052e&scoped=true&"
import script from "./SubheadingInput.vue?vue&type=script&lang=js&"
export * from "./SubheadingInput.vue?vue&type=script&lang=js&"
import style0 from "./SubheadingInput.vue?vue&type=style&index=0&id=4500052e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4500052e",
  null
  
)

export default component.exports